import React from 'react'

export default function Header() {
    return (
        <section className="page-header" id="contact-header">
            <h2>#let's_talk</h2>
            <p>Leave Message, We love to hearfrom you.</p>
        </section>

    )
}
